const numberComparator = (a: number, b: number) => a - b;

export default numberComparator;
